import api from "@modules/api/api";
import { keepPreviousData, useMutation, useQuery } from "@tanstack/react-query";
import vehicleQueryKeys from "../vehicleQueryKeys";
import { VinDecodeResponse } from "../types/VinDecodeResponse";

type DecodeVinRequest = {
  vin: string;
  localeCode: string;
};

const decodeVin = async ({ vin, localeCode }: DecodeVinRequest) => {
  return api.get<VinDecodeResponse>(`api/vehicles/vin-decode/${vin}`, {
    headers: { "Accept-Language": localeCode },
  });
};

export function useVinDecodeMutation() {
  return useMutation({ mutationFn: decodeVin });
}

export default function useVinDecodeQuery(
  vin: string,
  localeCode: string,
  enabled: boolean
) {
  const { data, error, isLoading, isFetching } = useQuery({
    queryKey: vehicleQueryKeys.vinLookup(vin, localeCode),
    queryFn: () => decodeVin({ vin, localeCode }),
    enabled,
    staleTime: Infinity,
    placeholderData: keepPreviousData,
  });

  return { vinDecode: data, error, isLoading, isFetching };
}
